import axios from 'axios';
import config from 'config/config';

/**
 * Gets Xero's invoices
 * @param token Xero account access token
 */
export async function getInvoices() {
    // Gets the tenant id required to request the invoices
    return axios.get(config.AWS_XERO_API);
}

/**
 * Gets Xero's invoices
 * @param token Xero account access token
 */
export async function getInvoicePDF(invoiceId) {
    // Gets the tenant id required to request the invoices
    return axios.get(`${config.AWS_XERO_API}${invoiceId}?accept=application/pdf`);
}

export default {
    getInvoices,
    getInvoicePDF
};
